(function () {
  function doScroll() {
    var hash = window.location.hash;
    if (!hash) return;

    var el = document.querySelector(hash);
    if (!el) return;

    var header =
      document.querySelector('sticky-header') ||
      document.querySelector('.header') ||
      document.querySelector('.shopify-section-header-sticky');

    var headerHeight = header ? header.offsetHeight : 0;

    var y = el.getBoundingClientRect().top + window.pageYOffset - headerHeight - 10;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  function scrollToHashMultiTry() {
    // Try multiple times because some themes load sections/animations late
    setTimeout(doScroll, 100);
    setTimeout(doScroll, 400);
    setTimeout(doScroll, 900);
    setTimeout(doScroll, 1500);
  }

  window.addEventListener('load', scrollToHashMultiTry);
  window.addEventListener('hashchange', scrollToHashMultiTry);

  // For Shopify themes with dynamic navigation/animations:
  document.addEventListener('DOMContentLoaded', scrollToHashMultiTry);
})();